// AUTO-GENERATED — не редактировать вручную. Регенерация: python3 scripts/gen-az-data.py
// Источники: AS_Life_перевод_AZ_готово.xlsx + AS_Life_перевод_AZ_доп_батч_готово.xlsx
// (переводы переводчика, 2026-07; при конфликте выигрывает база — первый файл).
// Ключ = исходная строка (RU/EN, как приходит с бэка/из БД или из Localized-мап кода),
// значение = азербайджанский. Строки с подстановками ${…} НЕ включены (нужна
// локализация шаблонов на бэке — см. лист 2 xlsx). SUPPLEMENT в gen-az-data.py.
// Всего строк: 816.
export const AZ_DB: Record<string, string> = {
  "/сут ×": "/gün ×",
  "1 год": "1 il",
  "10+ лет": "10+ il",
  "1C Business Analyst": "1C biznes analitiki",
  "1C Developer": "1C developeri",
  "1C Project Manager": "1C layihə meneceri",
  "1–3 года": "1–3 il",
  "2 года": "2 il",
  "2-НДФЛ, с места работы и др.": "Gəlir haqqında, iş yerindən və s.",
  "2-сменный": "2 növbəli",
  "3 года": "3 il",
  "3-сменный": "3 növbəli",
  "3–5 лет": "3–5 il",
  "5 лет": "5 il",
  "5-дневный": "5 günlük",
  "5–10 лет": "5–10 il",
  "6-дневный": "6 günlük",
  "AD-sync не сконфигурирован": "AD-sync konfiqurasiya edilməyib",
  "AS Life Project Manager": "AS Life layihə meneceri",
  "AZN — манат": "AZN — manat",
  "Advisor": "Müşavir",
  "BookStack недоступен": "BookStack əlçatan deyil",
  "Business Analyst": "Biznes analitik",
  "C-Level (C-Suite)": "C-Level (C-Suite)",
  "CEO / Управляющий директор / Президент": "CEO / İdarəedici direktor / Prezident",
  "CFO": "CFO",
  "Corporate Secretary": "Korporativ katib",
  "EUR — евро": "EUR — avro",
  "Entra не вернул refresh_token (нет scope offline_access)": "Entra refresh_token qaytarmadı (offline_access scope yoxdur)",
  "Executive Director": "İcraçı direktor",
  "FAQ не найден": "FAQ tapılmadı",
  "GBP — фунт стерлингов": "GBP — funt sterlinq",
  "General Director": "Baş direktor",
  "Group Finance Director": "Qrup üzrə maliyyə direktoru",
  "Group HR Director": "Qrup üzrə HR direktoru",
  "Group IT Director": "Qrup üzrə İT direktoru",
  "Group Internal Auditor": "Qrup üzrə daxili auditor",
  "Group Legal Director": "Qrup üzrə hüquq direktoru",
  "Group PR & Communication Director": "Qrup üzrə PR və Kommunikasiya direktoru",
  "HR": "HR",
  "HR Specialist": "HR üzrə mütəxəssis",
  "Head of Reporting & Budgeting": "Hesabatlıq və büdcələşdirmə üzrə rəhbər",
  "Head of Security Service": "Təhlükəsizlik Xidmətinin Rəisi",
  "Help Desk": "Help Desk",
  "IQ / логика": "IQ / məntiq",
  "IT Architect": "İT arxitektoru",
  "Internal Communications Manager": "Daxili kommunikasiyalar meneceri",
  "KB (BookStack) не сконфигурирован: задайте BOOKSTACK_URL / BOOKSTACK_TOKEN_ID / BOOKSTACK_TOKEN_SECRET": "KB (BookStack) konfiqurasiya edilməyib: BOOKSTACK_URL / BOOKSTACK_TOKEN_ID / BOOKSTACK_TOKEN_SECRET təyin edin",
  "Lawyer": "Hüquqşünas",
  "Leading Accountant": "Aparıcı mühasib",
  "Project Developer": "Layihə developeri",
  "RUB — российский рубль": "RUB — Rusiya rublu",
  "System Engineer": "Sistem mühəndisi",
  "USD — доллар США": "USD — ABŞ dolları",
  "VÖEN контрагента": "Kontragentin VÖEN-i",
  "VÖEN — ровно 10 цифр": "VÖEN düz 10 rəqəmdən ibarət olmalıdır",
  "ZUP_API_BASE_URL не задан — интеграция с 1С недоступна": "ZUP_API_BASE_URL təyin edilməyib — 1С ilə inteqrasiya əlçatan deyil",
  "ZUP_API_BASE_URL не задан — передача командировки невозможна": "ZUP_API_BASE_URL təyin edilməyib — ezamiyyətin ötürülməsi mümkün deyil",
  "ZUP_API_BASE_URL не задан — передача отпуска невозможна": "ZUP_API_BASE_URL təyin edilməyib — məzuniyyətin ötürülməsi mümkün deyil",
  "ZUP_API_BASE_URL не задан — финальная передача невозможна": "ZUP_API_BASE_URL təyin edilməyib — yekun ötürülmə mümkün deyil",
  "from/to — некорректные даты (YYYY-MM-DD)": "from/to — yanlış tarixlər (YYYY-MM-DD)",
  "reportsToId: узла нет": "reportsToId: node yoxdur",
  "title обязателен": "title mütləqdir",
  "to раньше from": "to from-dan tezdir",
  "userId: пользователя нет": "userId: istifadəçi yoxdur",
  "· текущий": "· cari",
  "Абонентский": "Abunə",
  "Аванс": "Avans",
  "Аванс + поэтапно": "Avans + mərhələlərlə",
  "Адрес прибытия": "Gəliş ünvanı",
  "Активные": "Aktiv",
  "Аренда": "İcarə",
  "База знаний не подключена": "Bilik bazası qoşulmayıb",
  "Банк/нотариус": "Bank/notarius",
  "Без опыта": "Təcrübəsiz",
  "Без раздела": "Bölməsiz",
  "Без сохранения з/п": "Ödənişsiz məzuniyyət",
  "Без справки заявка не отправляется — её проверит HR.": "Arayış olmadan müraciət göndərilmir — onu HR yoxlayacaq.",
  "Без файла-резюме закрыть заявку нельзя (КП-03)": "CV faylı olmadan müraciəti bağlamaq olmaz (KP-03)",
  "Берём…": "Götürülür…",
  "Бессрочный": "Müddətsiz",
  "Билеты, бронь и расходы (HR)": "biletlər, bron və xərclər (HR)",
  "Больничный": "Xəstəlik vərəqəsi",
  "Больничный зарегистрирован": "Xəstəlik vərəqəsi qeydiyyata alındı",
  "Больничный зарегистрирован (приказ создан HR)": "Xəstəlik vərəqəsi qeydiyyata alındı (əmr HR tərəfindən yaradıldı)",
  "Больничный лист": "Xəstəlik vərəqəsi",
  "Больничный согласован; HR подтвердил создание приказа. Выплату рассчитает 1С.": "Xəstəlik vərəqəsi razılaşdırıldı; HR əmrin yaradılmasını təsdiqlədi. Ödənişi 1С hesablayacaq.",
  "Бордо": "Bordo",
  "Бухгалтер (начисление)": "Mühasib (hesablama)",
  "Бухгалтер (расчёт)": "Mühasib (hesablama)",
  "Бухгалтерия": "Mühasibatlıq",
  "Бюджетированная": "Büdcələşdirilmiş",
  "В маршрут добавится согласование Ген. директора": "Marşruta Baş direktorun razılaşdırması əlavə olunacaq",
  "В работе": "İcradadır",
  "В работе (старт поиска)": "İcradadır (axtarışın başlanması)",
  "В списке рискованных не значится": "Riskli vergi ödəyiciləri siyahısında yoxdur",
  "Вакансия": "Vakansiya",
  "Вакансия закрыта (кандидат найден)": "Vakansiya bağlandı (namizəd tapıldı)",
  "Вакансия закрыта — кандидат найден": "Vakansiya bağlandı — namizəd tapıldı",
  "Валюта": "Valyuta",
  "Вернуть в группу": "Qrupa qaytar",
  "Версия": "Versiya",
  "Взять в работу": "İcraya götür",
  "Вид документа не распознан": "Sənədin növü tanınmadı",
  "Вид оплаты": "Ödəniş növü",
  "Вид услуги или товара": "Xidmətin və ya malın növü",
  "Вид штатной единицы": "Ştat vahidinin növü",
  "Виды проверки": "Yoxlama növləri",
  "Вилка зарплаты": "Maaş aralığı",
  "Вложение не найдено": "Əlavə tapılmadı",
  "Вложения": "Əlavələr",
  "Внешн. совместительство": "Xarici əvəzçilik",
  "Внутр. совместительство": "Daxili əvəzçilik",
  "Внутренний шаблон договора": "Daxili müqavilə şablonu",
  "Внутренняя ошибка 1С:ЗУП": "1С:ЗУП daxili xətası",
  "Водительское удостоверение": "Sürücülük vəsiqəsi",
  "Возвращаем…": "Qaytarılır…",
  "Возраст": "Yaş",
  "Возрастные ограничения": "Yaş məhdudiyyətləri",
  "Временная": "Müvəqqəti",
  "Время": "Vaxt",
  "Время окончания должно быть позже начала": "Bitmə vaxtı başlanğıcdan gec olmalıdır",
  "Все грейды": "Bütün qreydlər",
  "Все согласующие получат документ сразу. Он согласован, когда согласовали все; первое отклонение или возврат на доработку останавливают круг.": "Bütün razılaşdıranlar sənədi eyni vaxtda alır. Sənəd hamı razılaşdırdıqda razılaşdırılmış sayılır; ilk imtina və ya yenidən işlənməyə qaytarma dövrəni dayandırır.",
  "Вы закрываете маршрут: приложите скан договора, подписанного обеими сторонами — без него заявка не финализируется. Для отказа используйте «Отклонить» с причиной (скан не нужен).": "Marşrutu siz bağlayırsınız: hər iki tərəfin imzaladığı müqavilənin skanını əlavə edin — onsuz müraciət yekunlaşdırılmır. İmtina üçün səbəb göstərməklə «İmtina et» düyməsindən istifadə edin (skan lazım deyil).",
  "Вы не входите в группу этой задачи": "Siz bu tapşırığın qrupuna daxil deyilsiniz",
  "Выберите виды": "Növləri seçin",
  "Выберите образование": "Təhsili seçin",
  "Выберите опыт": "Təcrübəni seçin",
  "Выберите подразделение": "Bölməni seçin",
  "Выберите причину": "Səbəbi seçin",
  "Выберите причину открытия": "Açılma səbəbini seçin",
  "Выберите тип вакансии": "Vakansiya növünü seçin",
  "Выберите уровень": "Səviyyəni seçin",
  "Выберите уровень должности": "Vəzifə səviyyəsini seçin",
  "Выберите условия": "Şərtləri seçin",
  "Выбранный день — нерабочий (выходной или праздник)": "Seçilmiş gün iş günü deyil (istirahət və ya bayram)",
  "Выбранный день — нерабочий (выходной)": "Seçilmiş gün iş günü deyil (istirahət)",
  "Высшее": "Ali",
  "Выход в декрет": "Analıq məzuniyyətinə çıxış",
  "Выход на работу": "İşə çıxma",
  "ГГГГ-ММ-ДД": "İİİİ-AA-GG",
  "ГД": "BD",
  "Ген. директор": "Baş direktor",
  "Генеральная дирекция (CEO Office)": "Baş direksiya (CEO Office)",
  "Генеральный директор": "Baş direktor",
  "Город (или свой, если нет в списке)": "Şəhər (siyahıda yoxdursa, öz variantınız)",
  "Город / область / район / улица — если нужного города нет в списке или нужен трансфер": "Şəhər / vilayət / rayon / küçə — lazımi şəhər siyahıda yoxdursa və ya transfer lazımdırsa",
  "Госорганы": "Dövlət orqanları",
  "Госпортал сейчас недоступен — заполните данные вручную.": "Dövlət portalı hazırda əlçatan deyil — məlumatları əl ilə doldurun.",
  "График": "Qrafik",
  "Графит": "Qrafit",
  "Грейд": "Qreyd",
  "Данные больничного листа внесёт HR — прикладывать их к заявке не нужно.": "Xəstəlik vərəqəsinin məlumatlarını HR daxil edəcək — onları müraciətə əlavə etmək lazım deyil.",
  "Данные сохранённые — с госпорталом сейчас не сверяли": "Məlumatlar əvvəl saxlanılıb — dövlət portalı ilə hazırda üzləşdirilməyib",
  "Дата": "Tarix",
  "Дата выхода": "İşə çıxma tarixi",
  "Дата выхода на работу не может быть раньше даты окончания командировки": "İşə çıxma tarixi ezamiyyətin bitmə tarixindən əvvəl ola bilməz",
  "Дата выхода на работу не может быть раньше окончания поездки": "İşə çıxma tarixi səfərin bitməsindən əvvəl ola bilməz",
  "Дата начала": "Başlanğıc tarixi",
  "Дата окончания": "Bitmə tarixi",
  "Дата окончания раньше даты начала": "Bitmə tarixi başlanğıc tarixindən əvvəldir",
  "Дата рождения": "Doğum tarixi",
  "Дата рождения ребёнка": "Uşağın doğum tarixi",
  "Даты": "Tarixlər",
  "Дашборд доступен только ОИ/HR.": "Dashboard yalnız İD/HR üçün əlçatandır.",
  "Дашборд подбора доступен только ОИ/HR": "Kadr seçimi dashboardu yalnız İD/HR üçün əlçatandır",
  "Действия": "Əməliyyatlar",
  "Действует по": "Qüvvənin bitmə tarixi",
  "Действует с": "Qüvvəyə minmə tarixi",
  "Детали": "Təfərrüatlar",
  "Детали документа": "Sənədin təfərrüatları",
  "Диапазон from..to — не более 366 дней": "from..to diapazonu — 366 gündən çox deyil",
  "Директор / Старший директор": "Direktor / Baş direktor",
  "Директор департамента": "Departament direktoru",
  "Длительная болезнь (>30 дней)": "Uzunmüddətli xəstəlik (>30 gün)",
  "Длительность": "Müddət",
  "Длительность: —": "Müddət: —",
  "До 8 часов в месяц по согласованию": "Ayda 8 saatadək razılaşma ilə",
  "Добавить коллегу (поиск по имени)…": "Həmkar əlavə et (ada görə axtarış)…",
  "Добавить страницу": "Səhifə əlavə et",
  "Добавить участника": "İştirakçı əlavə et",
  "Добавить язык": "Dil əlavə et",
  "Добавлен согласующий": "Razılaşdıran əlavə edildi",
  "Добавьте согласующих — они получат документ по очереди.": "Razılaşdıranları əlavə edin — sənədi növbə ilə alacaqlar.",
  "Добавьте согласующих.": "Razılaşdıranları əlavə edin.",
  "Добавьте хотя бы одного участника": "Ən azı bir iştirakçı əlavə edin",
  "Договор": "Müqavilə",
  "Договор оказания услуг": "Xidmət müqaviləsi",
  "Договор поставки": "Təchizat müqaviləsi",
  "Договор, доп. соглашение, дополнение": "Müqavilə, əlavə razılaşma, əlavə",
  "Договор, который дополняется этим документом.": "Bu sənədin əlavə olunduğu müqavilə.",
  "Документ": "Sənəd",
  "Документ исправлен на доработке": "Sənəd yenidən işlənmə zamanı düzəldilib",
  "Документ не найден": "Sənəd tapılmadı",
  "Документ произвольной формы": "Sərbəst formalı sənəd",
  "Должность": "Vəzifə",
  "Дополнения к заявке…": "Müraciətə əlavələr…",
  "Дополнительное соглашение": "Əlavə razılaşma",
  "Дополнительные условия": "Əlavə şərtlər",
  "Доработать может только инициатор заявки": "Yalnız müraciətin təşəbbüskarı yenidən işləyə bilər",
  "Доработка": "təşəbbüskar tərəfindən yenidən işlənmə",
  "Доступ истёк": "Girişin müddəti bitib",
  "Другая компания группы": "Qrupun digər şirkəti",
  "Другое": "Digər",
  "Дублирующиеся должности в positions": "positions-da təkrarlanan vəzifələr",
  "За свой счёт": "Ödənişsiz məzuniyyət",
  "Загрузка…": "Yüklənir…",
  "Задайте BOOKSTACK_URL / BOOKSTACK_TOKEN_ID / BOOKSTACK_TOKEN_SECRET в as-life-api.": "as-life-api-də BOOKSTACK_URL / BOOKSTACK_TOKEN_ID / BOOKSTACK_TOKEN_SECRET təyin edin.",
  "Задача взята в работу": "Tapşırıq işə götürülüb",
  "Задача возвращена в группу": "Tapşırıq qrupa qaytarılıb",
  "Задача изменилась (назначена или обработана). Обновите и повторите.": "Tapşırıq dəyişdi (təyin edilib və ya emal edilib). Yeniləyin və təkrar edin.",
  "Задача назначена": "Tapşırıq təyin edilib",
  "Задача назначена другому сотруднику": "Tapşırıq başqa işçiyə təyin edilib",
  "Задача не назначена": "Tapşırıq təyin edilməyib",
  "Задача не найдена": "Tapşırıq tapılmadı",
  "Задача не связана с процессом Camunda": "Tapşırıq Camunda prosesi ilə əlaqəli deyil",
  "Задача переназначена": "Tapşırıq yenidən təyin edilib",
  "Задача уже обработана": "Tapşırıq artıq emal edilib",
  "Задачу уже взял другой сотрудник": "Tapşırığı artıq başqa işçi götürüb",
  "Законный представитель": "Qanuni nümayəndə",
  "Закрыта (кандидат найден)": "Bağlandı (namizəd tapıldı)",
  "Закрытие (ОИ/HR)": "Bağlanma (İD/HR)",
  "Закрытие вакансии (с прикреплением резюме) доступно в веб-версии портала": "Vakansiyanın bağlanması (CV əlavə etməklə) portalın veb versiyasında mümkündür",
  "Закрытие заявки на подбор — через действие «Закрыть с данными кандидата» (обязателен файл-резюме)": "Kadr seçimi müraciətinin bağlanması — «Namizəd məlumatları ilə bağla» əməliyyatı vasitəsilə (rezyume faylı mütləqdir)",
  "Закрытие с кандидатом (ОИ/HR)": "namizədin seçimi və müraciətin bağlanması (İD/HR)",
  "Закрытие…": "Bağlanır…",
  "Закрытые": "Bağlanmış",
  "Закрыть — кандидат найден": "Bağla — namizəd işə götürüldü",
  "Запрос не рассмотрен в срок — эскалация": "Sorğuya vaxtında baxılmadı — eskalasiya",
  "Запрошена повторная проводка": "Təkrar icra tələb olunub",
  "Запуск нового проекта": "Yeni layihənin başladılması",
  "Зарегистрирован": "Qeydiyyata alındı",
  "Зарегистрировано (приказ создан)": "Qeydiyyata alınıb (əmr yaradılıb)",
  "Зарплата": "Maaş",
  "Зарплата от": "Maaş (başlanğıc)",
  "Зарубежный": "Xarici",
  "Зарубежный контрагент — нерезидент Азербайджана: азербайджанского VÖEN у него может не быть, и в реестре Госналоговой его не проверить.": "Xarici kontragent Azərbaycanın qeyri-rezidentidir: onun Azərbaycan VÖEN-i olmaya bilər və onu Dövlət Vergi Xidmətinin reyestrində yoxlamaq mümkün deyil.",
  "Заявка будет оформлена на этого сотрудника: маршрут и лимиты — его.": "Müraciət bu işçinin adına rəsmiləşdiriləcək: marşrut və limitlər onundur.",
  "Заявка на больничный": "Xəstəlik vərəqəsi üçün müraciət",
  "Заявка на командировку прошла все согласования; командировочные начислены.": "Ezamiyyət müraciəti bütün razılaşdırmalardan keçdi; ezamiyyət xərcləri hesablandı.",
  "Заявка на материнский отпуск": "Analıq məzuniyyəti üçün müraciət",
  "Заявка на нового сотрудника": "Yeni işçi üçün müraciət",
  "Заявка на отгул": "İcazə üçün müraciət",
  "Заявка на отгул прошла согласование и проведена в 1С.": "İcazə müraciəti razılaşdırmadan keçdi və 1С-də icra edildi.",
  "Заявка на открытие вакансии": "Vakansiyanın açılması üçün müraciət",
  "Заявка на отпуск": "Məzuniyyət üçün müraciət",
  "Заявка на отцовский отпуск": "Atalıq məzuniyyəti üçün müraciət",
  "Заявка на подбор отменена": "Kadr seçimi müraciəti ləğv edildi",
  "Заявка на подбор персонала": "Kadr seçimi müraciəti",
  "Заявка на подбор прошла согласования; кандидат выбран, заявка закрыта.": "Kadr seçimi müraciəti razılaşdırmalardan keçdi; namizəd seçildi, müraciət bağlandı.",
  "Заявка на приём прошла все согласования и проведена в 1С.": "İşə qəbul müraciəti bütün razılaşdırmalardan keçdi və 1С-də icra edildi.",
  "Заявка на согласование документов": "Sənədlərin razılaşdırılması üçün müraciət",
  "Заявка на увольнение прошла все согласования и проведена в 1С.": "İşdən azad etmə müraciəti bütün razılaşdırmalardan keçdi və 1С-də icra edildi.",
  "Заявка на учебный отпуск прошла согласование и оформлена.": "Təhsil məzuniyyəti müraciəti razılaşdırmadan keçdi və rəsmiləşdirildi.",
  "Заявка не найдена": "Müraciət tapılmadı",
  "Заявка отклонена": "Müraciətə imtina edildi",
  "Заявка отменена": "Müraciət ləğv edilib",
  "Заявка отозвана": "Müraciət geri çağırıldı",
  "Заявка прошла все согласования и проведена в 1С.": "Müraciət bütün razılaşdırmalardan keçdi və 1С-də icra edildi.",
  "Заявка создана": "Müraciət yaradıldı",
  "Заявка создана. Пересекается с другими отсутствиями:": "Müraciət yaradıldı. Digər yoxluqlarla üst-üstə düşür:",
  "Заявка уже завершена": "Müraciət artıq tamamlanıb",
  "Заявку можно закрыть только на этапе подбора кандидата": "Müraciəti yalnız namizəd seçimi mərhələsində bağlamaq olar",
  "Заявление на отгул": "İcazə ərizəsi",
  "Заявление на отпуск": "Məzuniyyət ərizəsi",
  "Заявок нет.": "Müraciət yoxdur.",
  "Знание ПО": "Proqram təminatı bilikləri",
  "Знание языков": "Dil bilikləri",
  "ИТОГО": "YEKUN",
  "Идеи": "İdeyalar",
  "Изложите суть документа": "Sənədin məzmununu yazın",
  "Изменение подразделения/должности": "Bölmənin/vəzifənin dəyişməsi",
  "Изменить": "Dəyişdir",
  "Имя ребёнка": "Uşağın adı",
  "Индивидуальный вклад": "Fərdi töhfə",
  "Инициатор": "Təşəbbüskar",
  "Инициатор не найден": "Təşəbbüskar tapılmadı",
  "Интеграция с календарём почты не сконфигурирована": "Poçt təqvimi ilə inteqrasiya konfiqurasiya edilməyib",
  "Информация о вакансии": "Vakansiya haqqında məlumat",
  "Информируемые": "Məlumatlandırılanlar",
  "Иные навыки": "Digər bacarıqlar",
  "Иные причины": "Digər səbəblər",
  "Иные проверяемые навыки": "Yoxlanılan digər bacarıqlar",
  "Иные условия": "Digər şərtlər",
  "Исполнитель не входит в группу этой задачи": "İcraçı bu tapşırığın qrupuna daxil deyil",
  "Исправьте документ и отправьте снова — согласование пойдёт заново с первого согласующего. Маршрут и компанию изменить нельзя.": "Sənədi düzəldin və yenidən göndərin — razılaşdırma ilk razılaşdırandan yenidən başlayacaq. Marşrutu və şirkəti dəyişmək olmaz.",
  "Истечение срока": "Müddətin bitməsi",
  "История": "Tarixçə",
  "Источник": "Mənbə",
  "Источник (HeadHunter…)": "Mənbə (HeadHunter…)",
  "Источник документа": "Sənədin mənbəyi",
  "Исход проводки неизвестен — сверьте в 1С": "İcranın nəticəsi məlum deyil — 1С-də yoxlayın",
  "К процессам": "Proseslərə",
  "КБ": "KB",
  "Как в учредительных документах": "Təsis sənədlərində olduğu kimi",
  "Кандидат": "Namizəd",
  "Категория ВУ": "Sürücülük vəsiqəsinin kateqoriyası",
  "Ключевые навыки, ПО, инструменты…": "Əsas bacarıqlar, proqram təminatı, alətlər…",
  "Кого замещает": "Kimi əvəz edir",
  "Кого замещает (ФИО)": "Kimi əvəz edir (A.S.A.)",
  "Командировка": "Ezamiyyət",
  "Командировка застряла после проводки табеля": "Ezamiyyət tabel provodkasından sonra ilişib qaldı",
  "Командировка оформлена": "Ezamiyyət rəsmiləşdirildi",
  "Командировка оформлена (начисление завершено)": "Ezamiyyət rəsmiləşdirildi (hesablama tamamlandı)",
  "Командировка утверждена, табель проведён в 1С": "Ezamiyyət təsdiqləndi, tabel 1С-də icra edildi",
  "Командировки за рубеж": "Xarici ezamiyyətlər",
  "Командировки по стране": "Ölkədaxili ezamiyyətlər",
  "Комментарий": "Şərh",
  "Комментарий (необязательно)": "Şərh (istəyə bağlı)",
  "Комментарий (обязателен при отклонении/доработке)": "Şərh (imtina/yenidən işlənmə üçün mütləqdir)",
  "Комментарий (обязателен)": "Şərh (mütləqdir)",
  "Комментарий не найден": "Şərh tapılmadı",
  "Комментарий обязателен при этом решении по заявке на подбор": "Kadr seçimi müraciəti üzrə bu qərar zamanı şərh mütləqdir",
  "Компания": "Şirkət",
  "Компания-подписант": "İmzalayan şirkət",
  "Контент BookStack — нативно внутри портала": "BookStack kontenti — portalın daxilində nativ",
  "Контрагент": "Kontragent",
  "Контрагент с таким VÖEN в реестре Госналоговой не найден — заполните данные вручную.": "Bu VÖEN ilə kontragent Dövlət Vergi Xidmətinin reyestrində tapılmadı — məlumatları əl ilə doldurun.",
  "Короткий анонс (необязательно)": "Qısa anons (istəyə bağlı)",
  "Коррекция": "Yenidən işlənmə",
  "Кто едет": "Kim gedir",
  "Курс не найден": "Kurs tapılmadı",
  "Личностные качества": "Şəxsi keyfiyyətlər",
  "Личные качества": "Şəxsi keyfiyyətlər",
  "Личный автомобиль": "Şəxsi avtomobil",
  "МБ": "MB",
  "Магистратура": "Magistratura",
  "Маршрут согласования": "Razılaşdırma marşrutu",
  "Математика": "Riyaziyyat",
  "Материнский отпуск": "Analıq məzuniyyəti",
  "Медосмотр/здоровье": "Tibbi müayinə/sağlamlıq",
  "Менеджер / Старший менеджер": "Menecer / Baş menecer",
  "Менять пост можно только свой (или с ролью admin/hr)": "Postu yalnız özününkünü dəyişmək olar (və ya admin/hr rolu ilə)",
  "Местный": "Yerli",
  "Место работы": "İş yeri",
  "Месячный лимит исчерпан": "Aylıq limit tükənib",
  "Месячный лимит отгулов исчерпан (0 ч). Запуск заявки заблокирован.": "İcazələrin aylıq limiti tükənib (0 saat). Müraciətin başladılması bloklanıb.",
  "Мин. зарплата больше максимальной": "Min. maaş maksimumdan çoxdur",
  "Минимальная зарплата не может превышать максимальную": "Minimum əmək haqqı maksimumu keçə bilməz",
  "Можно изменять только своё (или с ролью admin)": "Yalnız özününkünü dəyişmək olar (və ya admin rolu ilə)",
  "На доработке": "Yenidən işlənmədə",
  "На доработку": "Yenidən işlənməyə göndər",
  "На контроле HR": "HR nəzarətində",
  "На листе «Employee» не найдена строка заголовка с колонкой employee_id": "«Employee» vərəqində employee_id sütunu olan başlıq sətri tapılmadı",
  "На листе «Employee» нет ни одной строки сотрудника (проверьте файл)": "«Employee» vərəqində heç bir işçi sətri yoxdur (faylı yoxlayın)",
  "На подписи": "İmzada",
  "На согласовании": "Razılaşdırmada",
  "На согласовании (ГД)": "Razılaşdırmada (BD)",
  "На согласовании (рук. СП)": "Razılaşdırmada (SB rəh.)",
  "На согласовании (руководитель)": "Razılaşdırmada (rəhbər)",
  "На указанную дату уже есть запись об отсутствии": "Göstərilən tarixdə artıq iştirakçı yoxluğu qeydi var",
  "Навыки вождения": "Sürücülük bacarıqları",
  "Назад": "Geri",
  "Название": "Adı",
  "Название вакансии": "Vakansiyanın adı",
  "Назначать может руководитель группы или администратор": "Qrup rəhbəri və ya administrator təyin edə bilər",
  "Назначить исполнителя": "İcraçı təyin et",
  "Наименование договора": "Müqavilənin adı",
  "Наименование контрагента": "Kontragentin adı",
  "Налоговый или регистрационный номер": "Vergi və ya qeydiyyat nömrəsi",
  "Напоминание отправлено": "Xatırlatma göndərildi",
  "Напомнить может только инициатор заявки": "Yalnız müraciətin təşəbbüskarı xatırlada bilər",
  "Направление": "İstiqamət",
  "Направление (страна · город)": "İstiqamət (ölkə · şəhər)",
  "Например, GB123456789 (можно не заполнять)": "Məsələn, GB123456789 (boş qoymaq olar)",
  "Например: ОРВИ": "Məsələn: kəskin respirator infeksiya",
  "Например: визит к врачу": "Məsələn: həkim ziyarəti",
  "Например: встреча с подрядчиком": "Məsələn: podratçı ilə görüş",
  "Например: деловые переговоры с партнёром": "Məsələn: tərəfdaşla işgüzar danışıqlar",
  "Например: договор поставки оборудования": "Məsələn: avadanlıq təchizatı müqaviləsi",
  "Например: ежегодный отпуск": "Məsələn: illik məzuniyyət",
  "Например: служебная записка о закупке": "Məsələn: satınalma üzrə xidməti məktub",
  "Например: соглашение о неразглашении": "Məsələn: məxfilik haqqında saziş",
  "Нарушен Data Contract (неверный формат/нет обязательного поля)": "Data Contract pozulub (yanlış format/mütləq sahə yoxdur)",
  "Начало": "Başlanğıc",
  "Начать поиск": "Axtarışa başla",
  "Начисление": "Hesablama",
  "Начисление (бухгалтер)": "Hesablama (mühasib)",
  "Начисление доступно только для трудового отпуска": "Hesablama yalnız əmək məzuniyyəti üçün əlçatandır",
  "Начисление командировочных": "ezamiyyət xərclərinin hesablanması (mühasib)",
  "Начисление отпускных (за 2 дня)": "Məzuniyyət haqqının hesablanması (2 gün ərzində)",
  "Начисление подтверждено": "Hesablama təsdiqlənib",
  "Начисление…": "Hesablanır…",
  "Начислить отпускные": "Məzuniyyət haqqını hesabla",
  "Начислять отпускные может только бухгалтер": "Məzuniyyət haqqını yalnız mühasib hesablaya bilər",
  "Начните вводить имя…": "Ad yazmağa başlayın…",
  "Не авторизовано (нужны Basic-auth креды ZUP_API_USER/PASSWORD)": "Avtorizasiya olunmayıb (Basic-auth kredensialları ZUP_API_USER/PASSWORD lazımdır)",
  "Не важно": "Fərq etməz",
  "Не найдено в базе знаний": "Bilik bazasında tapılmadı",
  "Не подключён": "Qoşulmayıb",
  "Не рассмотрено в срок": "Vaxtında baxılmayıb",
  "Не удалось загрузить данные": "Məlumatları yükləmək mümkün olmadı",
  "Не удалось загрузить дашборд.": "Dashboard-u yükləmək mümkün olmadı.",
  "Не удалось загрузить резюме": "CV-ni yükləmək mümkün olmadı",
  "Не удалось загрузить файл": "Faylı yükləmək mümkün olmadı",
  "Не удалось запустить процесс согласования. Повторите попытку позже.": "Razılaşdırma prosesini başlatmaq mümkün olmadı. Sonra yenidən cəhd edin.",
  "Не удалось определить пользователя": "İstifadəçini müəyyən etmək mümkün olmadı",
  "Не удалось определить согласующего": "Razılaşdıranı təyin etmək mümkün olmadı",
  "Не удалось отправить. Проверьте поля и попробуйте снова.": "Göndərmək mümkün olmadı. Sahələri yoxlayın və yenidən cəhd edin.",
  "Не удалось скачать файл": "Faylı yükləmək mümkün olmadı",
  "Неверный или незаданный sync-token": "sync-token yanlışdır və ya təyin edilməyib",
  "Недействующий": "Fəaliyyətsiz",
  "Недопустимый тип файла (изображение, видео, PDF, Office-документ или ZIP)": "Yolverilməz fayl növü (şəkil, video, PDF, Office sənədi və ya ZIP)",
  "Недостаточно прав": "Kifayət qədər hüquq yoxdur",
  "Неизвестный грейд должности": "Naməlum vəzifə qreydi",
  "Некорректный курсор пагинации": "Səhifələmə kursoru yanlışdır",
  "Некоторые сотрудники командировки не найдены": "Ezamiyyətin bəzi işçiləri tapılmadı",
  "Нельзя взять задачу по собственной заявке": "Öz müraciətinə aid tapşırığı götürmək olmaz",
  "Нельзя назначить исполнителем инициатора заявки": "Müraciətin təşəbbüskarını icraçı təyin etmək olmaz",
  "Нельзя назначить руководителем своего подчинённого (цикл в оргструктуре)": "Öz tabeçiliyində olanı rəhbər təyin etmək olmaz (orqstrukturda dövr)",
  "Нельзя согласовать собственную заявку": "Öz müraciətini razılaşdırmaq olmaz",
  "Необязательно": "İstəyə bağlı",
  "Необязательно: получат уведомление и доступ к документу, но согласование не блокируют.": "İstəyə bağlı: bildiriş və sənədə giriş alacaqlar, lakin razılaşdırmanı bloklamırlar.",
  "Неполная ставка": "Natamam ştat",
  "Нет доступа к вложению этой заявки": "Bu müraciətin əlavəsinə giriş yoxdur",
  "Нет доступа к этой заявке": "Bu müraciətə giriş yoxdur",
  "Нет доступных действий по документу": "Sənəd üzrə mümkün əməliyyat yoxdur",
  "Нет доступных исполнителей": "Mövcud icraçı yoxdur",
  "Нет открытой задачи для напоминания": "Xatırlatma üçün açıq tapşırıq yoxdur",
  "Новая редакция": "Yeni redaksiya",
  "Новая штатная единица": "Yeni ştat vahidi",
  "Новость не найдена": "Xəbər tapılmadı",
  "Номер договора": "Müqavilənin nömrəsi",
  "Номер листа": "Vərəq nömrəsi",
  "Номер основного договора": "Əsas müqavilənin nömrəsi",
  "Обновить": "Yenilə",
  "Обновлено": "Yeniləndi",
  "Обновляю…": "Yenilənir…",
  "Обновлён": "Yeniləndi",
  "Обоснование": "Əsaslandırma",
  "Обоснование и бюджет": "Əsaslandırma və büdcə",
  "Образование": "Təhsil",
  "Обучение / сертификаты": "Təlim / sertifikatlar",
  "Общее": "Ümumi",
  "Оверрайд не найден": "Overrayd tapılmadı",
  "Одобрено": "Təsdiqləndi",
  "Ожидает начисления бухгалтером": "Mühasib tərəfindən hesablama gözlənilir",
  "Ожидается файл .xlsx": ".xlsx faylı gözlənilir",
  "Окончание": "Bitmə",
  "Операционная дирекция (Исполнительный директор)": "Əməliyyat direksiyası (İcraçı direktor)",
  "Опыт": "Təcrübə",
  "Основное место": "Əsas iş yeri",
  "Основной договор": "Əsas müqavilə",
  "Основной отпуск": "Əmək məzuniyyəti",
  "Основной, дополнительный или за свой счёт": "Əsas, əlavə və ya öz hesabına",
  "Основной, учебный, за свой счёт и семейные": "Əsas, təhsil, öz hesabına və ailə məzuniyyətləri",
  "От 1 года": "1 ildən çox",
  "От компании зависит маршрут согласования. После подачи её изменить нельзя.": "Razılaşdırma marşrutu şirkətdən asılıdır. Göndərildikdən sonra şirkəti dəyişmək olmaz.",
  "Ответ 1С не является валидным JSON": "1С cavabı düzgün JSON deyil",
  "Отгул": "İcazə (qısamüddətli)",
  "Отгул не может приходиться только на обеденный перерыв": "İcazə yalnız nahar fasiləsinə düşə bilməz",
  "Отгул оформляется в пределах одного дня": "İcazə bir gün ərzində rəsmiləşdirilir",
  "Отгул согласован и проведён": "İcazə razılaşdırıldı və icra edildi",
  "Отдел информационных технологий": "İnformasiya texnologiyaları şöbəsi",
  "Отдел кадров (HR)": "Kadrlar şöbəsi (HR)",
  "Отдел коммуникаций и PR": "Kommunikasiya və PR şöbəsi",
  "Отдел управления персоналом": "Kadrların idarə edilməsi şöbəsi",
  "Отклонено": "İmtina edilib",
  "Отклонено / отозвано": "İmtina edilib / geri çağırılıb",
  "Отклонить": "İmtina et",
  "Отклонённые": "Rədd edilmiş",
  "Отключить": "Ayır",
  "Открыть": "Aç",
  "Открыть в BookStack": "BookStack-də aç",
  "Отмена": "Ləğv et",
  "Отмена…": "Ləğv edilir…",
  "Отменена": "Ləğv edildi",
  "Отменить": "Ləğv et",
  "Отменить заявку": "Müraciəti ləğv et",
  "Отменить заявку может инициатор или ОИ/HR": "Müraciəti təşəbbüskar və ya İD/HR ləğv edə bilər",
  "Отменённые": "Ləğv edilmiş",
  "Отозвано": "Geri çağırılıb",
  "Отозвать": "Geri çağır",
  "Отозвать заявку": "Müraciəti geri çağır",
  "Отправить": "Göndər",
  "Отправить повторно": "Yenidən göndər",
  "Отправка…": "Göndərilir…",
  "Отпуск": "Məzuniyyət",
  "Отпуск ещё не проведён в 1С — начисление недоступно": "Məzuniyyət hələ 1С-də icra edilməyib — hesablama əlçatan deyil",
  "Отпуск по уходу за ребёнком": "Uşağa qulluq məzuniyyəti",
  "Отпуск согласован и проведён": "Məzuniyyət razılaşdırıldı və icra edildi",
  "Отпускные начислены": "Məzuniyyət haqqı hesablandı",
  "Отпускные начислены на вашу карту. Хорошего отдыха!": "Məzuniyyət haqqı kartınıza köçürüldü. Yaxşı istirahət!",
  "Отпускные уже начислены": "Məzuniyyət haqqı artıq hesablanıb",
  "Отсутствие по": "Yoxluğun bitməsi",
  "Отсутствие с": "Yoxluğun başlanğıcı",
  "Отсутствие сотрудника по должности": "Vəzifə üzrə əməkdaşın olmaması",
  "Отцовский отпуск": "Atalıq məzuniyyəti",
  "Отчество (если есть)": "Atasının adı (varsa)",
  "Офис / локация": "Ofis / lokasiya",
  "Оформление больничного листа": "Xəstəlik vərəqəsinin rəsmiləşdirilməsi",
  "Оформление командировки": "Ezamiyyətin rəsmiləşdirilməsi",
  "Оформление референтом": "Referent tərəfindən rəsmiləşdirmə",
  "Оформление служебной поездки": "Xidməti səfərin rəsmiləşdirilməsi",
  "Очередной": "Əmək məzuniyyəti",
  "Ошибка проводки": "Provodka xətası",
  "Ошибка проводки (ждёт HR)": "Provodka xətası (HR gözləyir)",
  "Ошибка проводки — ожидает передачи в 1С": "Provodka xətası — 1С-ə ötürülmə gözlənilir",
  "Передано на следующий шаг": "Növbəti addıma yönləndirildi",
  "Переназначить исполнителя": "İcraçını yenidən təyin et",
  "Переотправить": "Yenidən göndər",
  "Переподключить": "Yenidən qoşul",
  "Период": "Dövr",
  "Персональную задачу нельзя вернуть в группу": "Şəxsi tapşırığı qrupa qaytarmaq olmaz",
  "Персональную задачу нельзя взять из группы": "Şəxsi tapşırığı qrupdan götürmək olmaz",
  "Персональную задачу нельзя переназначить": "Şəxsi tapşırığı yenidən təyin etmək olmaz",
  "Петроль": "Petrol",
  "Печать, подпись ГД и скан приказа (HR)": "əmrin çapı, baş direktorun imzası və skanı (HR)",
  "Плановая дата — дата рождения + 3 года. Очистите её, если уход оформляется бессрочно.": "Planlaşdırılan tarix — doğum tarixi + 3 il. Müddətsiz qulluq rəsmiləşdirilirsə, onu silin.",
  "Плательщик НДС": "ƏDV ödəyicisi",
  "По": "Bitmə",
  "По (плановая)": "Bitmə (planlaşdırılan)",
  "По беременности и родам": "Hamiləlik və doğuşa görə",
  "По инициативе работодателя": "İşəgötürənin təşəbbüsü ilə",
  "По рождению ребёнка, со справкой из клиники": "Uşağın doğulması ilə bağlı, klinikadan arayışla",
  "По собственному желанию": "Öz arzusu ilə",
  "По факту": "Fakt üzrə",
  "Повторить": "Yenidən cəhd et",
  "Подал (от имени)": "Təqdim edən (adından)",
  "Подал от имени": "Adından təqdim edib",
  "Подать от имени сотрудника": "İşçinin adından təqdim et",
  "Подача заявки": "Müraciətin verilməsi",
  "Подбор": "Kadr seçimi",
  "Подбор персонала": "Kadr seçimi",
  "Подключить календарь": "Təqvimi qoşun",
  "Подключён": "Qoşulub",
  "Подписал": "İmzaladı",
  "Подписанный договор": "İmzalanmış müqavilə",
  "Подписант": "İmzalayan",
  "Подписать": "İmzala",
  "Подпись": "General Director imzası",
  "Подпись (GD)": "İmza (GD)",
  "Подразделение": "Bölmə",
  "Подразделение (точно как в заявке)": "Bölmə (müraciətdəki kimi dəqiq)",
  "Подтвердить отмену": "Ləğvi təsdiq et",
  "Подчинение": "Tabelik",
  "Подчинение (ФИО рук.)": "Tabeçilik (rəh. A.S.A.)",
  "Поиск ведётся": "Axtarış aparılır",
  "Поиск по базе знаний…": "Bilik bazasında axtar…",
  "Поиск сотрудника (от 2 символов)": "İşçi axtarışı (ən azı 2 simvol)",
  "Пока нет книг": "Hələ kitab yoxdur",
  "Полная ставка": "Tam ştat",
  "Полный адрес прибытия (необязательно)": "Tam gəliş ünvanı (istəyə bağlı)",
  "Получили уведомление и доступ к документу; согласование не блокируют.": "Bildiriş və sənədə giriş alıblar; razılaşdırmanı bloklamırlar.",
  "Пользователь деактивирован — назначение в роль невозможно": "İstifadəçi deaktiv edilib — rola təyinat mümkün deyil",
  "Пользователь не найден": "İstifadəçi tapılmadı",
  "Понятно": "Aydındır",
  "Порядок согласования": "Razılaşdırma qaydası",
  "После старта поиска отменить заявку может только ОИ/HR": "Axtarış başladıqdan sonra müraciəti yalnız İD/HR ləğv edə bilər",
  "Пост не найден": "Post tapılmadı",
  "Почтовый календарь": "Poçt təqvimi",
  "Поэтапно": "Mərhələlərlə",
  "Предварительно; окончательные суммы — у бухгалтера и CFO": "İlkin; yekun məbləğlər — mühasib və CFO tərəfindən",
  "Предварительный маршрут: изменится руководитель или должность — изменится и он.": "İlkin marşrut: rəhbər və ya vəzifə dəyişərsə, marşrut da dəyişəcək.",
  "Предлагаемая должность": "Təklif olunan vəzifə",
  "Предмет": "Predmet",
  "Предмет договора": "Müqavilənin predmeti",
  "Прежние вложения остаются в карточке — согласующие видят, что смотрели на первом круге.": "Əvvəlki əlavələr kartda qalır — razılaşdıranlar ilk dövrədə nəyə baxdıqlarını görürlər.",
  "Приказ создан в 1С. Распечатайте, подпишите у CEO и приложите скан — без него «Выполнено» недоступно. Если приказ не подписан — «Отклонить» с указанием причины (скан не нужен).": "Əmr 1С-də yaradılıb. Çap edin, CEO-da imzalatdırın və skanı əlavə edin — onsuz addım bağlanmır. Əmr imzalanmayıbsa — səbəbi göstərməklə «İmtina et».",
  "Приказ создан в 1С. Распечатайте, подпишите у CEO и приложите скан — без него шаг не закрывается.": "Əmr 1С-də yaradıldı. Çap edin, CEO-da imzalayın və skanı əlavə edin — onsuz addım bağlanmır.",
  "Приказ — Референт CEO": "Əmr — CEO referenti",
  "Приказ: подпись и скан": "Əmr: imza və skan",
  "Приказы изменены (HR)": "Əmrlər dəyişdirildi (HR)",
  "Дописаны реквизиты контрагента": "Kontragentin rekvizitləri əlavə edildi",
  "Прикрепить проект договора": "Müqavilə layihəsini əlavə et",
  "Прикрепить резюме (PDF/DOC/DOCX)": "Rezyume əlavə et (PDF/DOC/DOCX)",
  "Прикрепить скан подписанного договора (PDF/JPG/PNG)": "İmzalanmış müqavilənin skanını əlavə et (PDF/JPG/PNG)",
  "Прикрепить скан приказа (PDF/JPG/PNG)": "Əmrin skanını əlavə et (PDF/JPG/PNG)",
  "Прикрепить справку (PDF/JPG/PNG)": "Arayışı əlavə edin (PDF/JPG/PNG)",
  "Прикрепить файл": "Fayl əlavə et",
  "Прикрепление резюме доступно в веб-версии портала": "Rezyumenin əlavə edilməsi portalın veb versiyasında mümkündür",
  "Прикрепление скана доступно в веб-версии портала": "Skanın əlavə edilməsi portalın veb versiyasında mümkündür",
  "Прикрепление справки доступно в веб-версии портала": "Arayışın əlavə edilməsi portalın veb versiyasında mümkündür",
  "Прикрепление файлов доступно в веб-версии портала": "Faylların əlavə edilməsi portalın veb versiyasında mümkündür",
  "Приложите скан подписанного приказа (uploadId) — без него шаг не закрывается": "İmzalanmış əmrin skanını əlavə edin (uploadId) — onsuz addım bağlanmır",
  "Приложить можно только свой загруженный файл": "Yalnız öz yüklədiyiniz faylı əlavə etmək olar",
  "Приложить новую редакцию": "Yeni redaksiyanı əlavə et",
  "Примерный расчёт расходов": "xərclərin təxmini hesablanması (mühasib)",
  "Примечание": "Qeyd",
  "Примечание (этапы собеседований…)": "Qeyd (müsahibə mərhələləri…)",
  "Причина": "Səbəb",
  "Причина (текст)": "Səbəb (mətn)",
  "Причина открытия (можно несколько)": "Açılma səbəbi (bir neçə ola bilər)",
  "Причина открытия (свободный текст)": "Açılma səbəbi (sərbəst mətn)",
  "Причина отмены (обязательно)": "Ləğv səbəbi (mütləqdir)",
  "Причины": "Səbəblər",
  "Приём": "İşə qəbul",
  "Приём на работу": "İşə qəbul",
  "Приём на работу согласован и проведён": "İşə qəbul razılaşdırıldı və icra edildi",
  "Проведено": "İcra edilib",
  "Проведено в 1С": "1С-də icra edildi",
  "Проверить": "Yoxla",
  "Проверить заново": "Yenidən yoxla",
  "Проверка": "Yoxlama",
  "Проверка не удалась — заполните данные вручную.": "Yoxlama alınmadı — məlumatları əl ilə doldurun.",
  "Проверка…": "Yoxlanılır…",
  "Проверяем контрагента в реестре Госналоговой…": "Kontragent Dövlət Vergi Xidmətinin reyestrində yoxlanılır…",
  "Проверяемые знания и навыки": "Yoxlanılan bilik və bacarıqlar",
  "Проводка прошла, следующий шаг не создан": "İcra baş tutdu, növbəti addım yaradılmadı",
  "Продолжается оформление приказа, подтверждение оплаты и начисление.": "Əmrin rəsmiləşdirilməsi, ödənişin təsdiqi və hesablama davam edir.",
  "Проект": "Layihə",
  "Проект (при наличии)": "Layihə (varsa)",
  "Проект договора": "Müqavilə layihəsi",
  "Проект договора обязателен, а выбор файла есть только в веб-версии — подайте заявку с компьютера.": "Müqavilə layihəsi mütləqdir, fayl seçimi isə yalnız veb versiyada mümkündür — müraciəti kompüterdən göndərin.",
  "Проектная": "Layihə (növ)",
  "Произвольный документ": "Sərbəst sənəd",
  "Профиль не найден": "Profil tapılmadı",
  "Работы": "İşlər",
  "Равна дате начала — отгул в один день": "Başlanğıc tarixi ilə eynidir — birgünlük icazə",
  "Разовый": "Birdəfəlik",
  "Рамочный": "Çərçivə",
  "Расторжение трудового договора": "Əmək müqaviləsinin ləğvi",
  "Расчёт бухгалтера": "Mühasibin hesablaması",
  "Ребёнок": "Uşaq",
  "Регистрационный номер присваивают юристы — можно оставить пустым и заполнить позже.": "Qeydiyyat nömrəsini hüquqşünaslar verir — boş saxlayıb sonra doldurmaq olar.",
  "Режим работы": "İş rejimi",
  "Резюме": "CV",
  "Референт CEO": "CEO referenti",
  "Референт CEO (билеты, бронь)": "CEO referenti (biletlər, bron)",
  "Решение по шагу": "Addım üzrə qərar",
  "Риск-статус контрагента сейчас проверить не удалось.": "Kontragentin risk statusunu hazırda yoxlamaq mümkün olmadı.",
  "Рискованный налогоплательщик": "Riskli vergi ödəyicisi",
  "Руководитель": "Rəhbər",
  "Руководитель СП": "SB rəhbəri",
  "Руководитель отдела": "Şöbə rəhbəri",
  "С": "Başlanğıc",
  "Сбой проводки в 1С": "1С-də provodka xətası",
  "Сбой проводки в 1С — нужна ручная обработка": "1С-də provodka xətası — əl ilə emal tələb olunur",
  "Сверено с реестром": "Reyestrlə üzləşdirilib",
  "Свободный текст и свой маршрут согласования": "Sərbəst mətn və öz razılaşdırma marşrutunuz",
  "Семейные обстоятельства": "Ailə vəziyyəti ilə bağlı",
  "Сервис 1С временно недоступен — не удалось проверить лимит отгулов. Попробуйте позже.": "1С xidməti müvəqqəti əlçatan deyil — icazə limitini yoxlamaq mümkün olmadı. Sonra cəhd edin.",
  "Сервис 1С временно недоступен — остаток отпуска не получен. Попробуйте позже.": "1С xidməti müvəqqəti əlçatan deyil — məzuniyyət qalığı alınmadı. Sonra cəhd edin.",
  "Сертификаты": "Sertifikatlar",
  "Система": "Sistem",
  "Скан подписанного экземпляра прикладывает последний согласующий — при завершении маршрута.": "İmzalanmış nüsxənin skanını marşrutu tamamlayarkən sonuncu razılaşdıran əlavə edir.",
  "Скан приказа": "Əmrin skanı",
  "Скачать": "Yüklə",
  "Скачиваем…": "Yüklənir…",
  "Скачивание вложений доступно в веб-версии портала": "Əlavələrin yüklənməsi portalın veb versiyasında mümkündür",
  "Скоро": "Tezliklə",
  "Служба безопасности": "Təhlükəsizlik xidməti",
  "Снять задачу может только её исполнитель или администратор": "Tapşırığı yalnız icraçısı və ya administrator geri götürə bilər",
  "Собеседования": "Müsahibələr",
  "Событие не найдено": "Hadisə tapılmadı",
  "Советники руководства": "Rəhbərliyin məsləhətçiləri",
  "Согласование": "Razılaşdırma",
  "Согласование ГД": "Baş direktor tərəfindən razılaşdırma",
  "Согласование договора": "Sənədlərin razılaşdırması",
  "Согласование договорных документов": "Müqavilə sənədlərinin razılaşdırılması",
  "Согласование начисления (CFO)": "Hesablamanın razılaşdırılması (CFO)",
  "Согласование рук. СП": "SB rəhbəri tərəfindən razılaşdırma",
  "Согласование руководителем": "rəhbər tərəfindən razılaşdırma",
  "Согласованная зарплата": "Razılaşdırılmış maaş",
  "Согласовано": "Razılaşdırılıb",
  "Согласовано всеми участниками": "Bütün iştirakçılar tərəfindən razılaşdırılıb",
  "Согласовать": "Razılaşdır",
  "Согласующие получат документ по очереди, в порядке списка.": "Razılaşdıranlar sənədi növbə ilə, siyahıdakı ardıcıllıqla alacaqlar.",
  "Согласующий": "Razılaşdıran",
  "Соглашение сторон": "Tərəflərin razılığı ilə",
  "Создан": "Yaradıldı",
  "Создание новой структуры": "Yeni strukturun yaradılması",
  "Сообщество не найдено": "İcma tapılmadı",
  "Сотрудник не может быть своим руководителем": "İşçi öz rəhbəri ola bilməz",
  "Сотрудник не найден": "İşçi tapılmadı",
  "Сотрудник не найден в 1С:ЗУП": "İşçi 1С:ЗУП-da tapılmadı",
  "Сотрудник не найден в 1С:ЗУП — остаток отпуска недоступен. Обратитесь в HR для сверки табельного номера.": "İşçi 1С:ЗУП-da tapılmadı — məzuniyyət qalığı əlçatan deyil. Tabel nömrəsinin uzlaşdırılması üçün HR-a müraciət edin.",
  "Сотрудник не найден в 1С:ЗУП — отгул нельзя провести. Обратитесь в HR для сверки данных (externalId).": "İşçi 1С:ЗУП-da tapılmadı — icazəni icra etmək olmaz. Məlumatların uzlaşdırılması üçün HR-a müraciət edin (externalId).",
  "Сохраняю…": "Saxlanılır…",
  "Специалист / Эксперт": "Mütəxəssis / Ekspert",
  "Справка": "Arayış",
  "Справка из клиники": "Klinikadan arayış",
  "Ср. дней до закрытия": "Bağlanmayadək orta gün sayı",
  "Ср. специальное": "Orta ixtisas",
  "Среднее": "Orta",
  "Срок действия": "Etibarlılıq müddəti",
  "Ставка": "Ştat dərəcəsi",
  "Ставка НДС (ƏDV)": "ƏDV dərəcəsi",
  "Стажёр": "Təcrübəçi",
  "Старт поиска (ОИ/HR)": "Axtarışın başlanması (İD/HR)",
  "Старший специалист": "Baş mütəxəssis",
  "Страна назначения (поиск)…": "Təyinat ölkəsi (axtarış)…",
  "Страны нет в справочнике норм (внутренних командировок тут нет)": "Ölkə normalar soraqçasında yoxdur (ölkədaxili ezamiyyətlər buraya daxil deyil)",
  "Сумма": "Məbləğ",
  "Суточные": "Gündəlik xərc (sutkalıq)",
  "Суточные показаны по нормам 1С — суммы вводить не нужно. Окончательный расчёт делают бухгалтер и CFO.": "Gündəlik xərc 1С normalarına görə göstərilir — məbləğ daxil etmək lazım deyil. Yekun hesablamanı mühasib və CFO aparır.",
  "Табель командировки проведён в 1С": "Ezamiyyət tabeli 1С-də icra edildi",
  "Табель проведён, но следующая задача не зазеркалилась — нужен ручной reconcile": "Tabel icra edildi, lakin növbəti tapşırıq əks olunmadı — əl ilə reconcile tələb olunur",
  "Таймер 3 ч истёк — эскалация": "3 saatlıq taymer bitdi — eskalasiya",
  "Текст": "Mətn",
  "Текст документа": "Sənədin mətni",
  "Текст новости": "Xəbərin mətni",
  "Телефон": "Telefon",
  "Тема": "Mövzu",
  "Тема документа": "Sənədin mövzusu",
  "Тестирование": "Testlər",
  "Техкомпетенции": "Texniki kompetensiyalar",
  "Технические компетенции (мин. 50 символов)": "Texniki kompetensiyalar (min. 50 simvol)",
  "Технические компетенции — минимум 50 символов": "Texniki kompetensiyalar — minimum 50 simvol",
  "Тимлид / Лид": "Timlid / Lid",
  "Тип вакансии": "Vakansiya növü",
  "Тип документа": "Sənədin növü",
  "Тип контрагента": "Kontragentin növü",
  "Тип контракта": "Müqavilənin tipi",
  "Тип отпуска": "Məzuniyyət növü",
  "Товары": "Mallar",
  "Точные даты действия проставит последний согласующий вместе со сканом подписанного договора.": "Dəqiq qüvvədə olma tarixlərini sonuncu razılaşdıran imzalanmış müqavilənin skanı ilə birlikdə qeyd edəcək.",
  "Требования": "Tələblər",
  "Требования к кандидату": "Namizədə tələblər",
  "Требуемый опыт": "Tələb olunan təcrübə",
  "Требуется": "Tələb olunur",
  "Требуется аутентификация": "Autentifikasiya tələb olunur",
  "Требуется тестирование": "Test tələb olunur",
  "У HR": "HR-da",
  "У ГД": "BD-də",
  "У Ген. директора": "Baş direktorda",
  "У ОИ/HR": "İD/HR-da",
  "У задачи нет адресата для напоминания": "Tapşırığın xatırlatma üçün ünvanı yoxdur",
  "У рук.": "Rəh.-də",
  "У рук. СП": "SB rəhbərində",
  "У руководителя": "Rəhbərdə",
  "У руководителя СП": "SB rəhbərində",
  "У сотрудника нет externalId (1С)": "İşçinin externalId-si (1С) yoxdur",
  "У сотрудника нет externalId (1С) — отгул нельзя провести": "İşçinin externalId-si (1С) yoxdur — icazəni icra etmək olmaz",
  "Уведомление в DSMF": "DSMF-ə bildiriş",
  "Уведомление в DSMF (бухгалтер)": "DSMF-ə bildiriş (mühasib)",
  "Увеличение объёма работ": "İş həcminin artması",
  "Увольнение": "İşdən azad etmə",
  "Увольнение согласовано и проведено": "İşdən azad etmə razılaşdırıldı və icra edildi",
  "Увольнение сотрудника": "Əməkdaşın işdən çıxması",
  "Удалить": "Sil",
  "Удалить?": "Silinsin?",
  "Узел не найден": "Node tapılmadı",
  "Укажите дату выхода": "İşə çıxma tarixini göstərin",
  "Укажите название вакансии": "Vakansiyanın adını göstərin",
  "Укажите образование": "Təhsili göstərin",
  "Укажите подразделение": "Bölməni göstərin",
  "Укажите срок действия договора — он уходит в 1С вместе со сканом. При «Отклонить» срок не нужен.": "Müqavilənin qüvvədə olma müddətini göstərin — o, skanla birlikdə 1C-yə göndərilir. «İmtina et» seçildikdə müddət tələb olunmur.",
  "Укажите требуемый опыт": "Tələb olunan təcrübəni göstərin",
  "Укажите фактическое место работы": "Faktiki iş yerini göstərin",
  "Укажите, кого замещает": "Kimi əvəz etdiyini göstərin",
  "Уровень должности": "Vəzifə səviyyəsi",
  "Условия": "Şərtlər",
  "Утверждение HR": "HR tərəfindən razılaşdırma",
  "Уточнение типа": "Növün dəqiqləşdirilməsi",
  "Уход за ребёнком": "Uşağa qulluq",
  "Участники": "İştirakçılar",
  "Участники собеседований": "Müsahibə iştirakçıları",
  "Учебный": "Təhsil",
  "Учебный отпуск": "Təhsil məzuniyyəti",
  "Учебный отпуск оформлен": "Təhsil məzuniyyəti rəsmiləşdirildi",
  "Учебный отпуск сотрудника (информационно)": "İşçinin təhsil məzuniyyəti (məlumat üçün)",
  "ФИО": "S.A.A.",
  "ФИО кандидата": "Namizədin S.A.A.",
  "ФИО кандидата (необязательно)": "Namizədin A.S.A. (istəyə bağlı)",
  "Файл": "Fayl",
  "Файл загружен не как документ ЭДО (нужен POST /uploads?purpose=edo_doc)": "Fayl ЭДО sənədi kimi yüklənməyib (POST /uploads?purpose=edo_doc lazımdır)",
  "Файл не найден": "Fayl tapılmadı",
  "Файл не передан": "Fayl ötürülmədi",
  "Файл не передан (multipart-поле \"file\" с .xlsx)": "Fayl ötürülmədi (.xlsx ilə \"file\" multipart sahəsi)",
  "Файл не читается как .xlsx (повреждён или неверный формат)": "Fayl .xlsx kimi oxunmur (zədələnib və ya yanlış format)",
  "Файл уже приложен к другой заявке": "Fayl artıq başqa müraciətə əlavə edilib",
  "Файл уже приложен к заявке": "Fayl artıq müraciətə əlavə edilib",
  "Фактическое место работы": "Faktiki iş yeri",
  "Фамилия ребёнка": "Uşağın soyadı",
  "Физлицо": "Fiziki şəxs",
  "Финансовый директор (CFO)": "Maliyyə direktoru (CFO)",
  "Финансовый отдел": "Maliyyə şöbəsi",
  "Фото": "Foto",
  "Хвойный": "İynəyarpaqlı",
  "Цель": "Məqsəd",
  "Цель командировки": "Ezamiyyətin məqsədi",
  "Цикл подчинения: узел нельзя подчинить собственному потомку": "Tabeçilik dövrü: node-u öz törəməsinə tabe etmək olmaz",
  "Черновик": "Qaralama",
  "Черновики новостей доступны только администратору": "Xəbər qaralamaları yalnız administrator üçün əlçatandır",
  "Что поставляется или оказывается по договору": "Müqavilə üzrə nə təchiz olunur və ya hansı xidmət göstərilir",
  "Шаблон контрагента": "Kontragentin şablonu",
  "Штатная единица": "Ştat vahidi",
  "Эта задача назначена не вам": "Bu tapşırıq sizə təyin edilməyib",
  "Это не заявка на подбор персонала": "Bu, kadr seçimi müraciəti deyil",
  "Юр. адрес": "Hüquqi ünvan",
  "Юридический отдел": "Hüquq şöbəsi",
  "Юридический отдел согласует договор первым — этот шаг обязателен и не удаляется.": "Hüquq şöbəsi müqaviləni birinci razılaşdırır — bu addım məcburidir və silinmir.",
  "Юрлицо": "Hüquqi şəxs",
  "Язык": "Dil",
  "Языки": "Dillər",
  "без ограничений": "məhdudiyyətsiz",
  "бессрочно": "müddətsiz",
  "билеты, бронь и расходы (HR)": "biletlər, bron və xərclər (HR)",
  "дн.": "gün",
  "до": "-dək",
  "доработка инициатором": "təşəbbüskar tərəfindən yenidən işlənmə",
  "из 1С": "1С-dən",
  "изменения — в истории ниже": "dəyişikliklər — aşağıdakı tarixçədə",
  "на доработку": "yenidən işlənməyə",
  "налоговый №": "vergi №",
  "напр. 6 мес.": "məs. 6 ay",
  "начисление бухгалтером": "mühasib tərəfindən hesablama",
  "начисление командировочных (бухгалтер)": "ezamiyyət xərclərinin hesablanması (mühasib)",
  "ожидает": "gözləyir",
  "ответств.": "məsul",
  "отклонено": "imtina edilib",
  "отозвано": "geri çağırılıb",
  "отправлено повторно": "yenidən göndərilib",
  "печать, подпись ГД и скан приказа (HR)": "əmrin çapı, baş direktorun imzası və skanı (HR)",
  "подбор кандидата и закрытие заявки (ОИ/HR)": "namizədin seçimi və müraciətin bağlanması (İD/HR)",
  "подпись General Director": "General Director imzası",
  "подтверждение оплаты (CFO)": "ödənişin təsdiqi (CFO)",
  "примерный расчёт расходов (бухгалтер)": "xərclərin təxmini hesablanması (mühasib)",
  "согласование HR": "HR tərəfindən razılaşdırma",
  "согласование Генеральным директором": "Baş direktor tərəfindən razılaşdırma",
  "согласование руководителем": "rəhbər tərəfindən razılaşdırma",
  "согласование руководителем СП": "SB rəhbəri tərəfindən razılaşdırma",
  "согласовано": "razılaşdırılıb",
  "старт поиска кандидата (ОИ/HR)": "namizəd axtarışının başlanması (İD/HR)",
  "сумму подтверждает 1С": "məbləği 1С təsdiqləyir",
}
